import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const INVENTORY_SECTIONS = [
  ['overview', 'Overview'], ['details', 'Edit details'], ['files', 'Files & photos'], ['notes', 'Notes']
];

export function InventoryWorkspaceSection({ name, active, children }) {
  return <section id={'inventory-section-' + name} hidden={active !== name} aria-label={INVENTORY_SECTIONS.find(section => section[0] === name)?.[1]}>{children}</section>;
}

export default function InventoryWorkspaceControls({ unit, ready, section, onSection, onBack, onInfo, onEdit, onFiles, onWorksheet, onCopy, onDuplicate }) {
  const title = unit?.model?.modelName || unit?.model?.modelNumber || unit?.serialA || unit?.serialB || 'Select a home';
  return <>
    <header className="inventory-workspace-record-header">
      <div className="inventory-workspace-identity">
        <Button variant="outline-secondary" className="inventory-back-homes" onClick={onBack}>Back to homes</Button>
        <div><h2>{title}</h2>{unit && <p>{[unit.serialA || unit.serialB, unit.unitLocation?.location, unit.inventoryStatus].filter(Boolean).join(' · ')}</p>}</div>
      </div>
      {unit && ready && <div className="inventory-workspace-actions">
        <Button variant="outline-primary" onClick={onFiles}>View files</Button>
        <Button variant="outline-primary" onClick={onWorksheet}>Worksheet</Button>
        <Dropdown>
          <Dropdown.Toggle variant="outline-secondary" id="inventory-unit-actions">More</Dropdown.Toggle>
          <Dropdown.Menu alignRight>
            <Dropdown.Item onClick={onInfo}>Unit information</Dropdown.Item>
            <Dropdown.Item onClick={onEdit}>Open edit panel</Dropdown.Item>
            <Dropdown.Item onClick={onCopy}>Copy unit details</Dropdown.Item>
            <Dropdown.Item onClick={onDuplicate}>Duplicate unit</Dropdown.Item>
            <Dropdown.Item as={Link} to={'/inventory/' + unit._id} target="_blank" rel="noopener noreferrer">Open full record</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>}
    </header>
    {unit && ready && <nav className="inventory-workspace-sections" aria-label="Inventory record sections">
      {INVENTORY_SECTIONS.map(([name, label]) => <Button key={name} variant={section === name ? 'primary' : 'outline-secondary'} aria-pressed={section === name} aria-controls={'inventory-section-' + name} onClick={() => onSection(name)}>{label}</Button>)}
    </nav>}
  </>;
}
